'use client';

import { useEffect, useState } from 'react';
import { ConversionEventBody } from '@interface/facebookEvents';
import * as Sentry from '@sentry/nextjs';
import { usePathname } from 'next/navigation';

export const useFacebookEvents = () => {
  const pathname = usePathname();

  const [fbc, setFbc] = useState<string | null>(null);
  const [fbp, setFbp] = useState<string | null>(null);
  const [viewContentData, setViewContentData] = useState<
    ConversionEventBody | undefined
  >(undefined);

  useEffect(() => {
    const getCookieValue = (name: string) => {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts?.pop()?.split(';').shift();
    };

    setFbc(getCookieValue('_fbc') || null);
    setFbp(getCookieValue('_fbp') || null);

    // La IP la pone el servidor (/api/fb-event): ya no se pide a /api/ip antes de enviar.
    setViewContentData({
      data: [
        {
          event_name: 'ViewContent',
          event_time: Math.floor(Date.now() / 1000),
          event_source_url: pathname,
          action_source: 'website',
          user_data: {
            client_user_agent: window.navigator.userAgent,
          },
        },
      ],
    });
  }, []);

  // Se envia por nuestro servidor, que anade la IP y el token: el token ya no esta en el navegador.
  async function sendConversionEvent(body: ConversionEventBody) {
    try {
      const response = await fetch('/api/fb-event', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
        // Que el envio acabe aunque el usuario cambie de pagina o cierre la pestana.
        keepalive: true,
      });
      if (!response.ok) {
        Sentry.captureMessage(`Facebook Conversions API: respuesta ${response.status}`, 'warning');
      }
    } catch (error) {
      // Un corte de red al salir de la pagina ("Load failed" en Safari, "Failed to fetch" en Chrome) no es
      // un fallo nuestro: es un evento de seguimiento que se pierde (25-oct, HOLAGLOW-FRONT-J).
      if (error instanceof TypeError) return;
      Sentry.captureException(error);
    }
  }

  return {
    sendConversionEvent,
    viewContentData,
    fbc,
    fbp,
  };
};
